var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskicon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 36C13.9333 36 13.3056 35.765 12.7833 35.295C12.2611 34.825 12 34.26 12 33.6V16.8C12 16.14 12.2611 15.575 12.7833 15.105C13.3056 14.635 13.9333 14.4 14.6667 14.4H20.2667C20.5556 13.68 21.0389 13.1 21.7167 12.66C22.3944 12.22 23.1556 12 24 12C24.8444 12 25.6056 12.22 26.2833 12.66C26.9611 13.1 27.4444 13.68 27.7333 14.4H33.3333C34.0667 14.4 34.6944 14.635 35.2167 15.105C35.7389 15.575 36 16.14 36 16.8V33.6C36 34.26 35.7389 34.825 35.2167 35.295C34.6944 35.765 34.0667 36 33.3333 36H14.6667ZM14.6667 33.6H33.3333V16.8H14.6667V33.6ZM17.3333 31.2H26.6667V28.8H17.3333V31.2ZM17.3333 26.4H30.6667V24H17.3333V26.4ZM17.3333 21.6H24H30.6667V19.2H17.3333V21.6ZM24 15.9C24.2889 15.9 24.5278 15.815 24.7167 15.645C24.9056 15.475 25 15.26 25 15C25 14.74 24.9056 14.525 24.7167 14.355C24.5278 14.185 24.2889 14.1 24 14.1C23.7111 14.1 23.4722 14.185 23.2833 14.355C23.0944 14.525 23 14.74 23 15C23 15.26 23.0944 15.475 23.2833 15.645C23.4722 15.815 23.7111 15.9 24 15.9Z",
    fill: "#0284C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon1);
export default __webpack_public_path__ + "static/media/taskicon1.af70fe0e4006c9bccc2a269407944cc2.svg";
export { ForwardRef as ReactComponent };